import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { VIDEOS_FEATURE_KEY } from './keys';
import { videosReducer } from './reducers/videos.reducer';
import { VideosEffects } from './effects/videos.effects';

@NgModule({
    imports: [CommonModule, StoreModule.forFeature(VIDEOS_FEATURE_KEY, videosReducer), EffectsModule.forFeature([VideosEffects])],
})
export class VideosStoreModule {}
